import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import {
  FiMoon,
  FiSun,
  FiMenu,
  FiX,
  FiBookOpen
} from 'react-icons/fi';

const Navbar = () => {
  const { darkMode, toggleDarkMode } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white dark:bg-gray-900 shadow-lg fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src="/images/web-logo.jpeg"
                alt="FutureLabGalaxy logo"
                className="h-11 w-11 rounded-lg object-contain bg-white"
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-teal-500 via-pink-500 to-slate-900 bg-clip-text text-transparent">
                FutureLabGalaxy Classroom
              </span>
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-4">
            <a
              href="../../../labsconnect.html"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-600 text-white font-semibold hover:bg-emerald-700 transition shadow-sm"
            >
              <FiBookOpen />
              Virtual Labs
            </a>

            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition"
              aria-label="Toggle dark mode"
            >
              {darkMode ?
                <FiSun className="text-yellow-400 text-xl" /> :
                <FiMoon className="text-gray-600 dark:text-gray-400 text-xl" />
              }
            </button>

            <a
              href="#create-room"
              className="px-4 py-2 rounded-full border border-emerald-600 text-emerald-700 dark:text-emerald-300 hover:bg-emerald-50 dark:hover:bg-gray-800 transition font-semibold"
            >
              Start Class
            </a>
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={toggleDarkMode}
              className="p-2 mr-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              {darkMode ? <FiSun className="text-yellow-400" /> : <FiMoon />}
            </button>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white dark:bg-gray-900 border-t dark:border-gray-700">
          <div className="px-4 pt-2 pb-3 space-y-2">
            <a
              href="#create-room"
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 text-center rounded-lg border border-emerald-600 text-emerald-700 dark:text-emerald-300 font-semibold"
            >
              Start Class
            </a>
            <a
              href="../../../labsconnect.html"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center space-x-2 px-3 py-2 rounded-lg bg-emerald-600 text-white"
              onClick={() => setIsOpen(false)}
            >
              <FiBookOpen />
              <span>Virtual Labs</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
